import { isLayer, StyleDc } from "@evergis/api";
import { call, put, select, takeEvery } from "redux-saga/effects";

import { api } from "../../evergis/api";
import { notifyError } from "../notifications/notifications";
import * as actions from "./layerTempStyle";
import { changeLayerTempStyle } from "./layerTempStyle";
import { getLayerTempStyle } from "./selectors";
import { setStyle } from "../style/style";
import { extractStyle, packStyle } from "../../evergis/core/symbol/compositeSymbol";
import { getScaleSegments, getSelectedSegment } from "../style/selectors";
import { getSegmentIndex } from "../../utils/style";

const apiFindLayer = (name: string) => api.layers.findOne(name);
const apiCreateStyle = (style: StyleDc) => api.styles.createStyle(style);
const apiUpdateStyle = (params: { id: string; style: StyleDc }) => api.styles.updateStyle(params.id, params.style);

function* createLayerTempStyle({ payload: layerInfo }: ReturnType<typeof actions.createLayerTempStyle>) {
  try {
    const layerTempStyle = yield select(getLayerTempStyle, layerInfo.name);

    if (layerTempStyle) return;

    if (isLayer(layerInfo) && layerInfo.style) {
      const { style } = yield call(apiFindLayer, layerInfo.name);
      const styleDc = layerInfo.style.serialize();

      yield put(setStyle(style));

      yield put(
        actions.setLayerTempStyle({
          // id: generateId(),
          layerName: layerInfo.name,
          style: layerInfo.type === "PostgresTileLayerService" ? style : extractStyle(styleDc),
        }),
      );

      const { id } = yield call(apiCreateStyle, style);

      yield put(actions.changeLayerTempStyle({ nextId: id, layerName: layerInfo.name }));
    }
  } catch (error) {
    yield put(notifyError({ title: "Не удалось создать временное оформление" }));
  }
}

function* updateLayerTempStyle(action: ReturnType<typeof actions.updateLayerTempStyle>) {
  try {
    const { layerName, style: updatedStyle } = action.payload;
    const { id } = (yield select(getLayerTempStyle, layerName)) || {};

    if (!id) return;

    const selectedSegment: number = yield select(getSelectedSegment);
    const scaleSegments: number[] = yield select(getScaleSegments);
    const scaleIndex = getSegmentIndex({ scaleSegments, selectedSegment });
    const isScaleSegmentation = scaleIndex >= 0;
    const { style: initialStyle, type } = yield call(apiFindLayer, layerName);

    const resultStyle =
      type === "PostgresTileLayerService"
        ? {
            ...initialStyle,
            symbol: {
              ...initialStyle.symbol,
              childSymbols: [
                updatedStyle.symbol,
                initialStyle.symbol?.childSymbols?.find(item => item.type === "rasterSymbol"),
              ],
            },
          }
        : { ...updatedStyle };

    if (isScaleSegmentation) {
      resultStyle.minResolution = 0;
      resultStyle.maxResolution = 0;
    }

    const { id: nextId } = yield call(apiUpdateStyle, {
      id,
      style: type === "PostgresTileLayerService" ? resultStyle : packStyle(resultStyle),
    });

    yield put(
      changeLayerTempStyle({
        layerName,
        style: resultStyle,
        nextId,
      }),
    );
  } catch (error) {
    yield put(notifyError({ title: "Не удалось создать временное оформление" }));
  }
}

function* layerTempStyleSaga() {
  yield takeEvery(actions.createLayerTempStyle, createLayerTempStyle);
  yield takeEvery(actions.updateLayerTempStyle, updateLayerTempStyle);
}

export default layerTempStyleSaga;
